<template>
  <div class="market">
    <div class="market-page-title">
      <span class="title_name">销售管理</span>
      <div class="upload-box" @click="handleImportFile">
        <img src="@/assets/image/land/addland.png" class="add-icons" />
        数据导入
      </div>
    </div>
    <!-- @tab-click="handleClickTabs" -->
    <el-tabs class="market-tabs" v-model="tabActiveName">
      <el-tab-pane label="数据表格" name="table"></el-tab-pane>
      <el-tab-pane label="图表分析" name="chart"></el-tab-pane>
    </el-tabs>
    <div class="market-l" v-show="tabActiveName == 'table'">
      <div class="my-table">
        <MyTable :tableData="tableData" :configTable="configTable" />
        <el-pagination
          v-if="tableData.length"
          background
          layout="prev, pager, next"
          :page-size="10"
          :total="total"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <div class="market-c" v-show="tabActiveName == 'chart'">
      <!-- @byUserSearch="handleByUserSearch" -->
      <div class="charts-filter-sticky">
        <ChartsFilter :userOptions="userOptions" @search="handleSearch" @byUserSearch="handleByUserSearch" />
        <div class="export-box" @click="handleExportFile">
          <img src="@/assets/image/land/addland.png" class="add-icons" />
          数据导出
        </div>
      </div>
      <div class="chart-box" ref="mixedChartBox">
        <div class="chart-title">销售总量及增长情况</div>
        <v-chart class="chart-items" autoresize :option="mixedOption"></v-chart>
      </div>
      <div class="chart-box" ref="lineChartBox">
        <div class="chart-title">单日产品销售走势图</div>
        <v-chart class="chart-items" autoresize :option="lineOption"></v-chart>
      </div>
      <div class="chart-box" ref="topUserChartBox">
        <div class="chart-title">客户购买总量TOP20</div>
        <v-chart class="chart-items" autoresize :option="topUserOption"></v-chart>
      </div>
      <div class="chart-box" ref="topProductChartBox">
        <div class="chart-title">商品销售总量TOP10</div>
        <v-chart class="chart-items" autoresize :option="topProductOption"></v-chart>
      </div>
      <div class="chart-box" ref="byUserLineChartBox">
        <div class="chart-title">{{ byUserTitle }}</div>
        <v-chart class="chart-items" autoresize :option="byUserLineOption" :update-options="{ replaceMerge: ['series'] }"></v-chart>
      </div>
    </div>
    <el-dialog
      class="big-pop small-pop"
      title=" "
      :visible.sync="fileImportShow"
      width="598px"
      :before-close="setFileImportClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="big-main">
        <div class="ware-title">
          <div class="left-line"></div>
          数据导入
        </div>
        <div class="add-form">
          <el-form ref="form" hide-required-asterisk label-position="top">
            <el-form-item label="" prop="cover">
              <el-upload
                ref="uploadFileRef"
                action="http://36.34.175.124:8801/project/digital2/hanshan/order/add"
                accept=".xlsx,.xls,.csv"
                :limit="1"
                :file-list="addFileList"
                :headers="uploadHeaders"
                :auto-upload="false"
                :on-exceed="handleFileExceed"
                :on-error="handleFileFail"
                :on-success="handleFileSuccess"
              >
                <el-button slot="trigger" type="primary">选取文件</el-button>
                <el-button style="margin-left: 20px" type="success" @click="submitUpload">文件导入</el-button>
                <div slot="tip" class="el-upload__tip">只能上传Excel/CSV文件</div>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
    <MyNav ref="MyNav" />
  </div>
</template>

<script>
import * as echarts from 'echarts/core'
import { TooltipComponent, GridComponent, LegendComponent, ToolboxComponent, DataZoomComponent } from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'
import { BarChart, LineChart } from 'echarts/charts'
import { UniversalTransition } from 'echarts/features'
import { CanvasRenderer } from 'echarts/renderers'
import screenfull from 'screenfull'

echarts.use([
  TooltipComponent,
  GridComponent,
  LegendComponent,
  ToolboxComponent,
  DataZoomComponent,
  BarChart,
  LineChart,
  CanvasRenderer,
  UniversalTransition
])
import {
  getMarketOrderListApi,
  getOrderCombochartApi,
  getOrderMultilinechartApi,
  getOrderTopUserChartApi,
  getOrderTopProductChartApi,
  getOrderByUserChartApi
} from '@/request/api.js'

const FULLSCREEN_ICON =
  'path://M128 32H32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32zM32 352c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V384c0-17.7-14.3-32-32-32zM512 32h-96c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32zM480 352c-17.7 0-32 14.3-32 32v64h-64c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z'
const EXIT_FULLSCREEN_ICON =
  'path://M64 160c-17.7 0-32-14.3-32-32V32C32 14.3 46.3 0 64 0h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96v64c0 17.7-14.3 32-32 32zM448 160c-17.7 0-32-14.3-32-32V64h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32zM64 352c17.7 0 32 14.3 32 32v64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32zM448 352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h64v-64c0-17.7 14.3-32 32-32z'
export default {
  provide: {
    [THEME_KEY]: 'dark'
  },
  components: {
    VChart,
    MyTable: () => import('@/components/MyTable.vue'),
    MyNav: () => import('@/components/MyNav.vue'),
    ChartsFilter: () => import('@/components/ChartsFilter.vue')
  },
  data() {
    return {
      byUserTitle: '商品购买情况',
      tabActiveName: 'table',
      dateRange: {},
      byUserParams: {},
      userOptions: [],
      addFileList: [],
      fileImportShow: false,
      uploadHeaders: {
        Authorization: localStorage.getItem('darsingToken')
      },
      lineOption: {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        toolbox: {
          right: 20,
          feature: {
            myFullScreen: {
              show: true,
              title: '全屏',
              icon: FULLSCREEN_ICON
            }
          }
        },
        grid: {
          top: '25%',
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },

        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value',
          name: ''
        },
        series: []
      },
      mixedOption: {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          right: 20,
          feature: {
            myFullScreen: {
              show: true,
              title: '全屏',
              icon: FULLSCREEN_ICON
            }
          }
        },
        legend: {
          data: []
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            },
            minorSplitLine: {
              show: false
            },
            splitLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            min: 0,
            minorSplitLine: {
              show: false
            },
            splitLine: {
              show: false
            }
            // max: 250,
            // interval: 50
          },
          {
            type: 'value',
            name: ''
            // min: 0,
            // max: 25,
            // interval: 5
          }
        ],
        series: [
          {
            name: '进口数量(万吨)',
            type: 'bar',
            barWidth: 20,
            data: []
          },
          {
            name: '数量增长率(%)',
            type: 'line',
            yAxisIndex: 1,
            data: []
          }
        ]
      },
      topUserOption: {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/>销量：{c}'
        },
        toolbox: {
          right: 20,
          feature: {
            myFullScreen: {
              show: true,
              title: '全屏',
              icon: FULLSCREEN_ICON
            }
          }
        },
        legend: {
          data: []
        },
        series: [
          {
            name: '',
            type: 'funnel',
            min: 0,
            minSize: '0%',
            maxSize: '100%',
            sort: 'descending',
            gap: 2,
            labelLine: {
              length: 10,
              lineStyle: {
                width: 1,
                type: 'solid'
              }
            },
            itemStyle: {
              borderColor: 'transparent'
              // borderWidth: 1
            },
            emphasis: {
              label: {
                fontSize: 20
              }
            },
            data: []
          }
        ]
      },
      topProductOption: {
        backgroundColor: 'transparent',
        toolbox: {
          right: 20,
          feature: {
            myFullScreen: {
              show: true,
              title: '全屏',
              icon: FULLSCREEN_ICON
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        legend: { data: [] },
        xAxis: {
          type: 'value'
          // boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          data: []
        },
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: 20,
            data: []
          }
        ]
      },
      byUserLineOption: {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          formatter: (params) => {
            if (!params || !params.length) return ''
            const lines = [params[0].axisValueLabel || params[0].name]
            params.forEach((item) => {
              const marker = item.marker || ''
              const value = item.value ?? '-'
              if (item.seriesType === 'bar') {
                const price = Number(value)
                const priceText = Number.isFinite(price) ? price.toFixed(2) : value
                lines.push(`${marker}${item.seriesName}：${priceText}元`)
              } else {
                lines.push(`${marker}${item.seriesName}：${value}`)
              }
            })
            return lines.join('<br/>')
          }
        },
        legend: {
          type: 'scroll',
          data: []
        },
        toolbox: {
          right: 20,
          feature: {
            myFullScreen: {
              show: true,
              title: '全屏',
              icon: FULLSCREEN_ICON
            }
          }
        },
        grid: {
          top: '25%',
          left: '3%',
          right: '4%',
          bottom: 60,
          containLabel: true
        },
        dataZoom: [
          {
            type: 'inside',
            xAxisIndex: 0
          },
          {
            type: 'slider',
            xAxisIndex: 0,
            height: 20,
            bottom: 10
          }
        ],
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              rotate: 30
            },
            minorSplitLine: {
              show: false
            },
            splitLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '总价(元)',
            min: 0,
            minorSplitLine: {
              show: false
            },
            splitLine: {
              show: false
            }
          },
          {
            type: 'value',
            name: '数量',
            min: 0
          }
        ],
        series: []
      },
      total: 0,
      current_page: 1,
      tableData: [],
      configTable: [
        {
          prop: 'order_no',
          label: '单据编号',
          width: '180'
        },
        {
          prop: 'date',
          label: '时间',
          width: '100'
        },
        {
          prop: 'order_type',
          label: '业务类型',
          width: '80'
        },
        {
          prop: 'user_name',
          label: '客户名称',
          width: ''
        },
        {
          prop: 'salesman',
          label: '业务员',
          width: '80'
        },
        {
          prop: 'product_code',
          label: '商品编码',
          width: '100'
        },
        {
          prop: 'product_type',
          label: '产品类型',
          width: '100'
        },
        {
          prop: 'product_name',
          label: '商品名称',
          width: ''
        },
        {
          prop: 'store_name',
          label: '仓库名称',
          width: ''
        },
        {
          prop: 'uint',
          label: '单位',
          width: '80'
        },
        {
          prop: 'num',
          label: '数量',
          width: '80'
        },
        {
          prop: 'price',
          label: '含税单价',
          width: '80'
        },
        {
          prop: 'total_price',
          label: '价税合计',
          width: '80'
        },
        {
          prop: 'spec',
          label: '规格',
          width: '80'
        },
        {
          prop: 'total',
          label: '合计',
          width: '80'
        },
        {
          prop: 'ton',
          label: '吨',
          width: '80'
        },
        {
          prop: 'remark',
          label: '备注',
          width: ''
        }
      ],
      statList: [],
      isBoxShowNum: 14
    }
  },
  created() {
    this.getList()
    this.getOrderCombochart()
    this.getOrderMultilinechart()
    this.getOrderTopUserList()
    this.getOrderTopProductList()
  },
  mounted() {
    this.$set(this.mixedOption.toolbox.feature.myFullScreen, 'onclick', () => {
      this.toggleChartFullscreen('mixedChartBox')
    })
    this.$set(this.lineOption.toolbox.feature.myFullScreen, 'onclick', () => {
      this.toggleChartFullscreen('lineChartBox')
    })
    this.$set(this.topUserOption.toolbox.feature.myFullScreen, 'onclick', () => {
      this.toggleChartFullscreen('topUserChartBox')
    })
    this.$set(this.topProductOption.toolbox.feature.myFullScreen, 'onclick', () => {
      this.toggleChartFullscreen('topProductChartBox')
    })
    this.$set(this.byUserLineOption.toolbox.feature.myFullScreen, 'onclick', () => {
      this.toggleChartFullscreen('byUserLineChartBox')
    })
    if (screenfull.isEnabled) {
      screenfull.on('change', this.onChartFullscreenChange)
    }
  },
  beforeDestroy() {
    if (screenfull.isEnabled) {
      screenfull.off('change', this.onChartFullscreenChange)
    }
  },
  methods: {
    toggleChartFullscreen(refName) {
      if (!screenfull.isEnabled) {
        this.$notify({
          title: '提示',
          message: '不支持全屏',
          type: 'info'
        })
        return
      }
      const el = this.$refs[refName]
      if (!el) return
      screenfull.toggle(el)
    },
    onChartFullscreenChange() {
      this.updateFullscreenFeature('mixedOption', 'mixedChartBox')
      this.updateFullscreenFeature('lineOption', 'lineChartBox')
      this.updateFullscreenFeature('topUserOption', 'topUserChartBox')
      this.updateFullscreenFeature('topProductOption', 'topProductChartBox')
      this.updateFullscreenFeature('byUserLineOption', 'byUserLineChartBox')
    },
    updateFullscreenFeature(optionKey, refName) {
      const feature = this[optionKey].toolbox.feature.myFullScreen
      const isCurrent = screenfull.isFullscreen && screenfull.element === this.$refs[refName]
      feature.title = isCurrent ? '退出全屏' : '全屏'
      feature.icon = isCurrent ? EXIT_FULLSCREEN_ICON : FULLSCREEN_ICON
    },
    handleSearch(params) {
      this.dateRange = params
      this.getOrderCombochart(params)
      this.getOrderMultilinechart(params)
      if (this.byUserParams.user_name) {
        this.byUserTitle = `${this.byUserParams.user_name}的商品购买情况`
        this.getOrderByUserChart({ ...this.byUserParams, ...params })
      }
    },
    handleByUserSearch(params) {
      this.byUserParams = params || {}
      if (params?.user_name) {
        this.byUserTitle = `${params.user_name}的商品购买情况`
        this.getOrderByUserChart({ ...this.byUserParams, ...this.dateRange })
      } else {
        this.byUserTitle = '商品购买情况'
        this.byUserLineOption.xAxis[0].data = []
        this.byUserLineOption.legend.data = []
        this.byUserLineOption.series = []
      }
    },
    submitUpload() {
      this.$refs.uploadFileRef.submit()
    },
    async getOrderTopUserList(params = {}) {
      const { code, results } = await getOrderTopUserChartApi(params)
      if (code != 0) return
      this.userOptions = results
      this.topUserOption.series[0].data = results.map((item) => ({ value: item.total_sum, name: item.user_name }))
    },
    async getOrderTopProductList(params = {}) {
      const { code, results } = await getOrderTopProductChartApi(params)
      if (code != 0) return
      const reversedResults = results.toReversed()
      this.topProductOption.series[0].data = reversedResults.map((item) => ({ value: item.total_num, name: item.product_name }))
      this.topProductOption.yAxis.data = reversedResults.map((item) => item.product_name)
    },
    async getOrderByUserChart(params = {}) {
      const { code, results } = await getOrderByUserChartApi(params)
      if (code != 0) return

      const list = Array.isArray(results?.data) ? results.data : Array.isArray(results) ? results : []
      if (!list.length) {
        this.byUserLineOption.xAxis[0].data = []
        this.byUserLineOption.legend.data = []
        this.byUserLineOption.series = []
        return
      }

      const dateSet = new Set()
      const productSet = new Set()
      const priceMap = new Map()
      const numMap = new Map()

      list.forEach((item) => {
        const date = item.date || ''
        const product = item.product_name || ''
        if (!date || !product) return
        dateSet.add(date)
        productSet.add(product)
        const key = `${date}|${product}`
        priceMap.set(key, (priceMap.get(key) || 0) + Number(item.total_price || 0))
        numMap.set(key, (numMap.get(key) || 0) + Number(item.num || 0))
      })

      const dates = [...dateSet].sort()
      const products = [...productSet]
      if (!dates.length || !products.length) {
        this.byUserLineOption.xAxis[0].data = []
        this.byUserLineOption.legend.data = []
        this.byUserLineOption.series = []
        return
      }

      const roundPrice = (val) => Math.round(Number(val || 0) * 100) / 100
      const barSeries = products.map((product) => ({
        name: product,
        type: 'bar',
        stack: 'price',
        barWidth: 20,
        data: dates.map((date) => roundPrice(priceMap.get(`${date}|${product}`) || 0))
      }))

      const lineSeries = {
        name: '购买数量',
        type: 'line',
        yAxisIndex: 1,
        data: dates.map((date) => products.reduce((sum, product) => sum + (numMap.get(`${date}|${product}`) || 0), 0))
      }

      this.byUserLineOption.xAxis[0].data = dates
      this.byUserLineOption.legend.data = [...products, '购买数量']
      this.byUserLineOption.series = [...barSeries, lineSeries]
    },
    async getOrderCombochart(params = {}) {
      const { code, results } = await getOrderCombochartApi(params)
      if (code != 0) return
      this.mixedOption.xAxis[0].data = results.categories
      this.mixedOption.series = results.series
      results.series.forEach((item, index) => {
        this.mixedOption.yAxis[index].name = item.name
      })
    },
    async getOrderMultilinechart(params = {}) {
      const { code, results } = await getOrderMultilinechartApi(params)
      if (code != 0) return
      this.lineOption.legend.data = results.legend
      this.lineOption.yAxis.name = results.unit
      this.lineOption.xAxis.data = results.categories
      results.series.forEach((item, index) => {
        this.lineOption.series[index] = {
          name: item.name,
          stack: 'Total',
          type: 'line',
          data: item.data
        }
      })
    },
    async getList() {
      const { code, results } = await getMarketOrderListApi({
        pn: this.pn,
        ps: 10
      })
      if (code != 0) return
      this.tableData = results.data
      this.total = results.count
      this.pn = results.pn
      this.ps = results.ps
    },
    setFileImportClose() {
      this.fileImportShow = false
      this.addFileList = []
    },
    handleFileExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    handleFileFail() {
      this.$notify.error({
        title: '错误',
        message: '上传失败，稍后尝试'
      })
    },
    handleFileSuccess(res, file) {
      if (file.percentage === 100) {
        this.getList()
        this.addFileList = []

        this.fileImportShow = false
        this.$notify({
          title: '成功',
          message: '文件已导入',
          type: 'success'
        })
      }
    },
    handleImportFile() {
      this.fileImportShow = true
    },
    escapeCsvCell(value) {
      const str = value == null ? '' : String(value)
      if (/[",\n\r]/.test(str)) {
        return `"${str.replace(/"/g, '""')}"`
      }
      return str
    },
    buildCategorySeriesCsv(title, categories, seriesList) {
      const categoriesArr = Array.isArray(categories) ? categories : []
      const series = (Array.isArray(seriesList) ? seriesList : []).filter((item) => item && Array.isArray(item.data))
      if (!categoriesArr.length || !series.length) return ''
      const header = ['类目', ...series.map((item) => item.name || '')].map((cell) => this.escapeCsvCell(cell)).join(',')
      const rows = categoriesArr.map((category, index) => {
        const cells = [category, ...series.map((item) => (item.data[index] != null ? item.data[index] : ''))]
        return cells.map((cell) => this.escapeCsvCell(cell)).join(',')
      })
      return [`【${title}】`, header, ...rows].join('\n')
    },
    buildNameValueCsv(title, list, nameLabel = '名称', valueLabel = '数值') {
      const data = Array.isArray(list) ? list.filter((item) => item && (item.name != null || item.value != null)) : []
      if (!data.length) return ''
      const header = [nameLabel, valueLabel].map((cell) => this.escapeCsvCell(cell)).join(',')
      const rows = data.map((item) => [item.name, item.value].map((cell) => this.escapeCsvCell(cell)).join(','))
      return [`【${title}】`, header, ...rows].join('\n')
    },
    downloadCsv(content, filename) {
      const uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(content)
      const link = document.createElement('a')
      link.href = uri
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleExportFile() {
      const sections = []
      const mixedSection = this.buildCategorySeriesCsv(
        '销售总量及增长情况',
        this.mixedOption?.xAxis?.[0]?.data,
        this.mixedOption?.series
      )
      if (mixedSection) sections.push(mixedSection)

      const lineSection = this.buildCategorySeriesCsv(
        '单日产品销售走势图',
        this.lineOption?.xAxis?.data,
        this.lineOption?.series
      )
      if (lineSection) sections.push(lineSection)

      const topUserSection = this.buildNameValueCsv(
        '客户购买总量TOP20',
        this.topUserOption?.series?.[0]?.data,
        '客户名称',
        '销量'
      )
      if (topUserSection) sections.push(topUserSection)

      const topProductSection = this.buildNameValueCsv(
        '商品销售总量TOP10',
        this.topProductOption?.series?.[0]?.data,
        '商品名称',
        '销量'
      )
      if (topProductSection) sections.push(topProductSection)

      const byUserSection = this.buildCategorySeriesCsv(
        this.byUserTitle || '商品购买情况',
        this.byUserLineOption?.xAxis?.[0]?.data,
        this.byUserLineOption?.series
      )
      if (byUserSection) sections.push(byUserSection)

      if (!sections.length) {
        this.$notify({
          title: '提示',
          message: '暂无可导出的统计数据',
          type: 'warning'
        })
        return
      }

      const { date_start, date_end } = this.dateRange || {}
      const filename =
        date_start && date_end ? `销售统计数据[${date_start} 至 ${date_end}].csv` : '销售统计数据.csv'
      this.downloadCsv(sections.join('\n\n'), filename)
    },
    handleCurrentChange(val) {
      this.pn = val
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
.market {
  width: 100%;
  height: 100vh;
  background: #071a2c;
  padding: 70px 0 30px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0;
  }
  .market-page-title {
    width: 100%;
    height: 60px;
    color: #fff;
    background-color: #0e2138;
    position: relative;
    padding: 0 30px 0 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 30px;
      transform: translateY(-50%);
      width: 4px;
      height: 22px;
      background: #3e90e5;
      border-radius: 2px;
    }
    .title_name {
      font-size: 22px;
      font-weight: 400;
      color: #fff;
    }
    .upload-box {
      width: 143px;
      height: 40px;
      background-color: #3e90e5;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      float: right;
      margin-left: 10px;
      &:hover {
        opacity: 0.8;
      }
      .add-icons {
        width: 18px;
        height: 18px;
        margin-right: 13px;
      }
    }
  }
  /deep/.el-tabs.market-tabs {
    width: 100%;
    padding: 0 30px;
    .el-tabs__item {
      color: #fff;
      &.is-active {
        color: #3e90e5;
      }
    }
    .el-tabs__active-bar {
      background-color: #3e90e5;
    }
  }

  .market-l {
    width: 100%;
    // height: 100%;
    height: calc(100vh - 150px);
    background: #142d4c;
    padding: 30px 30px 0;

    .my-table {
      width: 100%;
      // height: 690px;
    }
  }
  .market-c {
    width: 100%;
    min-height: calc(100vh - 200px);
    background: #0e2138;
    margin: 0 16px;
    padding: 30px 30px;
    display: flex;
    flex-wrap: wrap;
    .charts-filter-sticky {
      flex: 0 0 100%;
      position: sticky;
      top: 0px;
      z-index: 100;
      background: #0e2138;
      padding-bottom: 10px;
      display: flex;
      justify-content: flex-start;
      .export-box {
        width: 143px;
        height: 40px;
        background-color: #3e90e5;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        float: right;
        margin-left: 10px;
        &:hover {
          opacity: 0.8;
        }
        .add-icons {
          width: 18px;
          height: 18px;
          margin-right: 13px;
        }
      }
    }
    .chart-box {
      width: 50%;
      height: 400px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 0 40px 0;
      .chart-title {
        width: 100%;
        height: 33px;
        line-height: 33px;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        color: #fff;
        margin-bottom: 28px;
        flex-shrink: 0;
      }
      .chart-items {
        width: 100%;
        height: 100%;
        min-height: 0;
        flex: 1;
      }
      &:fullscreen,
      &:-webkit-full-screen {
        width: 100%;
        height: 100%;
        background: #0e2138;
        padding: 30px;
        box-sizing: border-box;
      }
    }
  }

  .big-pop {
    /deep/.el-dialog {
      width: 598px !important;
      background-color: inherit;
    }

    /deep/.el-dialog__body {
      padding: 0;
    }

    /deep/.el-dialog__headerbtn {
      font-size: 26px;
      top: 64px;
      right: 50px;
      font-weight: bold;
    }
  }

  .big-pop {
    /deep/.el-form-item {
      margin-bottom: 32px;
    }

    /deep/.el-button span {
      color: #fff;
    }

    /deep/.el-dialog__headerbtn {
      top: 71px;
      right: 44px;
    }

    /deep/.dialog-footer {
      margin-top: 40px;
      padding: 0 0 0 119px;
    }

    .ok-button {
      width: 150px;
      height: 40px;
      margin-right: 44px;
    }

    .no-button {
      width: 150px;
      height: 40px;
      border: 1px solid #385576;
      background-color: #0f243d;
    }

    .big-main {
      width: 598px;
      height: 539px;
      background: url(../assets/image/configure/process/addbgimg.png) no-repeat center center;
      background-size: cover;
      padding: 45px 55px;
      overflow: hidden;
      .ware-title {
        font-size: 22px;
        color: #fff;
        font-weight: bold;
        display: flex;
        margin-bottom: 40px;
        align-items: center;
        .left-line {
          background-color: #fff;
          width: 4px;
          height: 21px;
          border-radius: 3px;
          margin-right: 10px;
        }
      }

      .block {
        width: 100%;
        height: calc(100% - 124px);
        overflow: auto;
        padding: 0 2px;

        &::-webkit-scrollbar {
          width: 1px;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: #ccc;
        }
      }
      /deep/.uploadCover {
        width: 158px;
        height: 105px;
        display: flex;
        .el-upload--picture-card {
          width: 100%;
          height: 100%;
          line-height: 105px;
        }
        .el-upload-list--picture-card .el-upload-list__item {
          width: 158px;
          height: 105px;
        }
        &.active {
          .el-upload--picture-card {
            display: none;
          }
        }
      }
      /deep/.el-card {
        background-color: #081c30;
        border: none;
      }

      /deep/.el-timeline-item__tail {
        border-left: 2px solid #385576;
      }

      /deep/.el-timeline-item__timestamp {
        font-size: 18px;
        color: #fff;
      }

      /deep/.el-card__body {
        width: 450px;
        min-height: 83px;
        padding: 18px 15px;
      }

      /deep/.el-timeline-item__node {
        background-color: #67c23a;
      }

      /deep/.el-timeline-item.active {
        .el-timeline-item__node {
          background-color: #e60000;
        }
      }

      .info-col1 {
        margin-bottom: 16px;

        span {
          font-size: 18px;
          color: #fff;
          margin-right: 16px;
        }

        .num {
          color: #e60000;
        }

        .num.active {
          color: #67c23a;
        }
      }

      .info-col2 {
        span {
          font-size: 14px;
        }

        .text1 {
          color: #57708d;
          margin-right: 14px;
        }

        .text2 {
          color: #fff;
          margin-right: 20px;
        }

        .text3 {
          color: #57708d;
          margin-right: 10px;
        }

        .text4 {
          color: #3e90e5;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      /deep/.el-input__inner {
        background-color: #081c30;
        border: 1px solid #385576;
        color: #57708d;
        width: 353px;
      }

      /deep/.el-textarea__inner {
        background-color: #081c30;
        border: 1px solid #385576;
        color: #57708d;
        width: 353px;
        height: 120px;
        resize: none;
      }

      /deep/.el-form-item__label {
        font-size: 14px;
        color: #fff;
        padding: 0 24px 0 0;
      }

      /deep/.el-radio__input.is-checked + .el-radio__label {
        color: #fff;
      }

      /deep/.el-radio {
        color: #fff;
      }
      .add-form {
        width: 100%;
        height: calc(100% - 56px);
        overflow-y: scroll;
        &::-webkit-scrollbar {
          width: 7px;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: #3e90e5;
        }
      }
    }
  }
}
</style>
